import { render } from "./App.vue?vue&type=template&id=c02e6320&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=c02e6320&lang=css"

import exportComponent from "/mnt/7e868b86-35b8-4c8b-aa8f-81c8fe9154a3/work/Илюха/texuspex.ru/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__